import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useGlobalState } from '../../contexts/GlobalStateContext';
import TransparentHeader from './TransparentHeader';
import WhiteHeader from './WhiteHeader';
import ScrolledHeader from './ScrolledHeader';
import './styles.css';

const Header = () => {
  const location = useLocation();
  // Proteção temporária: não quebre se contexto global não existir
  const globalState = useGlobalState && useGlobalState();
  const handleOpenLogin = globalState?.handleOpenLogin || (() => {});
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Páginas que usam o WhiteHeader
  const transparentHeaderPages = [
    '/about',
    '/contact',
    '/plans',
    '/privacy-policy',
    '/cookie-policy',
    '/complaints-book',
    '/faq',
    '/agencies'
  ];

  // Páginas que usam o TransparentHeader
  const whiteHeaderPages = [
    '/dashboard',
    '/property',
    '/search-results',
    '/register',
    '/cadastro',
  ];

  // Verifica se a página atual está na lista de páginas que usam WhiteHeader
  const shouldUseWhiteHeader = whiteHeaderPages.some(page => 
    location.pathname.startsWith(page)
  );

  // Verifica se a página atual está na lista de páginas que usam TransparentHeader
  const shouldUseTransparentHeader = transparentHeaderPages.some(page => 
    location.pathname.startsWith(page)
  );

  // Renderiza o header apropriado com base na página atual
  if (shouldUseWhiteHeader) {
    return <WhiteHeader />;
  } else if (shouldUseTransparentHeader) {
    return <TransparentHeader />;
  } else {
    // Para todas as outras páginas, usa o TransparentHeader como padrão
    return <TransparentHeader />;
  }
};

export default Header;